import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import type { TSoilIrrigationActivityScope } from 'stores/detailsPanelStore/detailsPanelStore'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'

type TZoneEmitterIds = NonNullable<TPoint['configuration']['soilProbeIntersectingZoneIdsWithEmitters']>

export const getAvailableEmittersForScope = ({
  irrigationActivityScope,
  soilPoint,
}: {
  irrigationActivityScope: TSoilIrrigationActivityScope
  soilPoint: TPoint | null | undefined
}): TZoneEmitterIds => {
  const zoneEmitterIds = soilPoint?.configuration.soilProbeIntersectingZoneIdsWithEmitters ?? []

  if (irrigationActivityScope === 'ZONE') return zoneEmitterIds

  const pressureTransducerEmitterTypes = soilPoint?.configuration.irrigationEmitterTypesAvailable ?? []

  return zoneEmitterIds.filter((zoneEmitterId) =>
    pressureTransducerEmitterTypes.includes(zoneEmitterId.split('|||')[1] as TEmitterType),
  )
}
